import React, { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";



// Custom Components
import Filter from "@Components/Filter";
import Table from "@Components/Table";
import {
    ATTENDANCE_BY_MONTH_URL,
    COMPANY_FETCH_URL,
    ESTATE_FETCH_URL,
    REGION_FETCH_URL,
    ZONE_FETCH_URL,
} from "../../configs/constants";

const today = new Date();
const options = { timeZone: 'Asia/Kuala_Lumpur' };
let month = today.toLocaleDateString('en-GB', options).split('/')[1];
let currentYear = today.getFullYear().toString();

const pageNumberDropdown = true;


let model = [
    { id: "employee_id", label: "Employee ID", type: "string" },
    { id: "name", label: "Name", type: "string" },
    { id: "supervisor_name_id", label: "Supervisor", type: "string" },
    { id: "mobile_number", label: "Mobile Number", type: "string" },
    { id: "estate", label: "Estate", type: "string" },
    { id: "attendance_date", label: "Date", type: "date" },
    { id: "check_in_time", label: "Today Clock In Time", type: "string" },
    { id: "check_out_time", label: "Today Clock Out Time", type: "string" },
    { id: "status", label: "Status", type: "string" },
    { id: "remarks", label: "Type of Attendance", type: "string" },
];
const getMonthOptions = () => {
    const months = Array.from({ length: 12 }, (_, index) => {
        const monthNumber = (index + 1).toString().padStart(2, "0");
        return {
            id: monthNumber,
            name: monthNumber, 
        };
    });


    return months;
};




const validationSchema = Yup.object({
    selected_month: Yup.string().required("Month is required").nullable().typeError("Month is required"),
    selected_year: Yup.string().required("Year is required").nullable().typeError("Year is required"),
    company: Yup.string().required("Company is required").nullable().typeError("Company is required"),
    zone: Yup.string()
        .required("Zone is required")
        .typeError("Invalid Zone")
        .nullable(),
    region: Yup.string()
        .required("Region is required")
        .typeError("Invalid Region")
        .nullable(),
    estate: Yup.string()
        .required("Estate is required")
        .typeError("Invalid Estate")
        .nullable(),
});

const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

const getZoneValues = (e, setDisableRegion) => {
 //   if (!e || e.length === 0) {
    if (!e || e.length === 0 || e.label == "N/A") {
        setDisableRegion(true);
    }
    else {
        setDisableRegion(false);
    }

};
const getRegionValues = (e, setDisableEstate) => {
    if (!e || e.length === 0) {
        setDisableEstate(true);
    }
    else {
        setDisableEstate(false);
    }

};

const getEstateValues = (e, setDisableDivision) => {
    if (!e || e.length === 0) {
        setDisableDivision(true);
    }
    else {
        setDisableDivision(false);
    }

};

export default function AttendanceRecordByMonth() {
    const [disableZone, setDisableZone] = useState(true);
    const [disableRegion, setDisableRegion] = useState(true);
    const [disableEstate, setDisableEstate] = useState(true);
    const [disableDivision, setDisableDivision] = useState(true);
    const [filtersApplied, setFiltersApplied] = useState(false);

    const selected_month = useMemo(() => getMonthOptions(), []);

    const selected_year = useMemo(() => 
      Array.from({ length: currentYear - 2006 }, (_, index) => {
        const year = 2007 + (index + 1);
        return {
          id: year.toString(),
          name: year.toString(),
          };
      }), []);


    const filterFields = [
        {
            type: "reactselect",
            label: "Month (mm)",
            name: "selected_month",
            outerOptions: selected_month,
            required: true,


        },
        {
            type: "reactselect",
            label: "Year (yyyy)",
            name: "selected_year",
            outerOptions: selected_year,
            required: true,


        },
        {
            type: "reactselect",
            name: "company",
            label: "Company",
            proxyUrl: COMPANY_FETCH_URL,
            getValue: (e) => getCompanyValues(e, setDisableZone),
            paginated: true,
            required: true,
      
      
          },


        {
            type: "reactselect",
            name: "zone",
            label: "Zone",
            proxyUrl: ZONE_FETCH_URL,
            getValue: (e) => getZoneValues(e, setDisableRegion),
            paginated: true,
            required: true,
            disabled:disableZone,
            optionsDependsOn: "company",
        },
        {
            type: "reactselect",
            name: "region",
            label: "Region",
            proxyUrl: REGION_FETCH_URL,
            paginated: true,
            disabled: disableRegion,
            getValue: (e) => getRegionValues(e, setDisableEstate),
            optionsDependsOn: "zone",
            required: true,

        },
        {
            type: "reactselect",
            name: "estate",
            label: "Estate",
            proxyUrl: ESTATE_FETCH_URL,
            paginated: true,
            disabled: disableEstate,
            getValue: (e) => getEstateValues(e, setDisableDivision),
            required: true,
            optionsDependsOn: "region",
        },

    ];
    const details = useLocation();
    const filterInitialValues = {
        selected_month: (selected_month.find(option => option.id === month) || {}).id,
        selected_year: (selected_year.find(option => option.id === currentYear) || {}).id,
        zone: "",
        region: "",
        estate: "",
        company: "",
    };

    
      
    let filters = {};
    // if ("searchParams" in details) {
    //     if (details.searchParams.from_date.dateForAPI) {
    //         filters["from_date"] = details.searchParams.from_date.dateForAPI;
    //     }
    //     if (details.searchParams.to_date.dateForAPI) {
    //         filters["to_date"] = details.searchParams.to_date.dateForAPI;
    //     }
    //     if (details.searchParams.status) {
    //         filters["status"] = details.searchParams.status;
    //     }
    // }
    const [filterValues, setFilterValues] = useState(filters);
    const onFilterRequest = (values) => {
        setFiltersApplied(true);

        let filterObj = {};
        for (const [key, value] of Object.entries(values)) {
            if (value !== null && value !== "") {
                filterObj[key] = value;
            }
        }
        //filterObj.status = null
        setFilterValues(filterObj);
    };
    const clearFilter = () => {
        filterInitialValues.status = null
        location.reload();
    }

    return (
        <div>
            <Filter
                initialValues={filterInitialValues}
                filterFields={filterFields}
                onSubmit={onFilterRequest}
                onClear={clearFilter}
                validationSchema={validationSchema}
                showPrompt={false}

            />
            {filtersApplied ? (

                <Table
                    proxyURL={ATTENDANCE_BY_MONTH_URL}
                    model={model}
                    excelExport={{ fileName: "AttendanceRecord" }}
                    filterValues={filterValues}
                    noFilter
                    isBackOffice
                    noAddButton
                    pageNumberDropdown={pageNumberDropdown}

                />
            ) : (
                <Table
                    proxyURL={null}
                    model={model}
                    excelExport={{ fileName: "AttendanceRecord" }}
                    filterValues={filterValues}
                    noFilter
                    isBackOffice
                    noAddButton
                    pageNumberDropdown={pageNumberDropdown}

                />
            )}

        </div>
    );
}
